import customerIllustration from './assets/customer.svg';
import planIllustration from './assets/plan.svg';
import reportIllustration from './assets/report.svg';
import userIllustration from './assets/user.svg';

export type PermissionKey = 'customer' | 'managePlan' | 'report' | 'userMgmt';
export type UserPermissionKey = 'products' | 'sales' | 'integrations' | 'automation rules';
export type PermissionValue = 'READ' | 'WRITE' | 'RESTRICT' | 'SUPERADMIN' | 'FULL';

export const PERMISSION_KEYS: PermissionKey[] = ['customer', 'managePlan', 'report', 'userMgmt'];
export const User_PermissionKey:UserPermissionKey[] = ['products', 'sales', 'integrations', 'automation rules'];


export const DEFAULT_PERMISSIONS: Record<PermissionKey, PermissionValue> = {
  customer: 'RESTRICT',
  managePlan: 'RESTRICT',
  report: 'RESTRICT',
  userMgmt: 'RESTRICT'
};

export const OPTION_LABELS: Record<PermissionValue, string> = {
  READ: 'Read',
  WRITE: 'Write',
  RESTRICT: 'No Access',
  SUPERADMIN: 'Super Admin',
  FULL : 'Write + Delete'
};

export type UserPermissionItem = {
  key: string;
  display_name: string;
  permissions: { label: string; value: 'READ' | 'WRITE' | 'RESTRICT' | 'SUPERADMIN' | 'FULL'}[];
};

export interface PermissionConfig {
  title: string;
  subtitle: string;
  illustration: string;
  options: PermissionValue[];
}

export const PERMISSION_CONFIG: Record<PermissionKey, PermissionConfig> = {
  customer: {
    title: 'Customer',
    subtitle: 'Set access level for this module',
    illustration: customerIllustration,
    options: ['READ', 'WRITE', 'RESTRICT', 'SUPERADMIN']
  },
  managePlan: {
    title: 'Manage Plan',
    subtitle: 'Control plan management capabilities',
    illustration: planIllustration,
    options: ['READ', 'WRITE', 'RESTRICT']
  },
  report: {
    title: 'Report',
    subtitle: 'Set access level for analytics',
    illustration: reportIllustration,
    options: ['READ', 'RESTRICT']
  },
  userMgmt: {
    title: 'User Management',
    subtitle: 'Decide how users are administered',
    illustration: userIllustration,
    options: ['READ', 'WRITE', 'RESTRICT']
  }
};
export const USER_PERMISSION_CONFIG: Record<UserPermissionKey, PermissionConfig> = {
  products: {
    title: 'Products',
    subtitle: 'Manage access to product information and actions',
    illustration: customerIllustration, // You can replace with a specific icon if available
    options: ['READ', 'WRITE', 'RESTRICT']
  },
  sales: {
    title: 'Sales',
    subtitle: 'Control permissions for sales data and reports',
    illustration: reportIllustration, // Replace if you have a better one
    options: ['READ', 'WRITE', 'RESTRICT']
  },
  integrations: {
    title: 'Integrations',
    subtitle: 'Configure access to connected platforms and APIs',
    illustration: planIllustration, // Reuse or add a new illustration
    options: ['READ', 'WRITE']
  },
  'automation rules': {
    title: 'Automation Rules',
    subtitle: 'Define who can create or edit automation rules',
    illustration: userIllustration, // Reuse or replace
    options: ['READ', 'WRITE', 'RESTRICT']
  }
};


export const mapPermissionsToApiPayload = (
  permissions: Partial<Record<PermissionKey, PermissionValue>>
) => ({
  customer_access: permissions.customer ?? DEFAULT_PERMISSIONS.customer,
  manage_plan_access: permissions.managePlan ?? DEFAULT_PERMISSIONS.managePlan,
  report_access: permissions.report ?? DEFAULT_PERMISSIONS.report,
  user_access: permissions.userMgmt ?? DEFAULT_PERMISSIONS.userMgmt
});
